// extracted by mini-css-extract-plugin
export var container = "tooltip-module--container--9209e";
export var content = "tooltip-module--content--23cf9";
export var open = "tooltip-module--open--8f56c";
export var panel = "tooltip-module--panel--290ee";